import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpEvent, HttpParams } from '@angular/common/http';
import { BaseService, ApiResult } from './base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class erpInvoiceService {

  myAppUrl: string = "";

  constructor(private _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.myAppUrl = baseUrl;
  }

  getTasacionInvoices(tasacionId: number) {
    return this._http.get(this.myAppUrl + 'api/ERPInvoiceLine/getTasacionInvoices?TasacionID=' + tasacionId);
  }
}
